import {create} from "zustand";

export const useBuyOneClickStore = create((set, get) => ({
    open: false,
    loading: false,
    productId: null,
    productData: [],
    productDataCurrent: {},
    onlineDiscount: 0,
    onlineDiscountSbp: 0,

    openModal: () => set({open: true}),

    reset: () => set({
        open: false,
        loading: false,
        productId: null,
        productData: [],
        productDataCurrent: {},
        onlineDiscount: 0,
        onlineDiscountSbp: 0,
    }),

    closeModal: () => get().reset(),

    setLoading: (loading) => set({loading}),

    setData: (data) => set((state) => ({
        ...state,
        ...data
    })),

    /**
     * Переключаем нужный размер
     * @param el - выбранный елемент
     */
    switchSize: (el = {}) => set({productDataCurrent: el}),
}));
